import {RegionHelper} from "../helpers/regionHelper";

function initProductMedia(){
	var $productMedia = $('.js-product-media'),
		$productMediaList = $('.js-product-media-list'),
	    $productMediaItems = $('.js-product-media-item'),
		galleryimagesObject = [],
        clippedimagesObject = [],       
        vignetteimagesObject = [],
        supplementaryimagesObject = [],       
        lifestyleimagesObject = [],
        packagingimagesObject = [], 
		websitevideoObject = [],  
		installationvideoObject = [],   
        threeSixtyObject = [];

	$productMediaItems.each(function(){
		var $this = $(this),
			id = $this.data('id'),
			type = $this.data('type'),
			index = $this.index() + 1;

		  //push all images to the imagesObject
             if (type === 'galleryimage') {
                galleryimagesObject.push(id);
            }else if (type === 'clippedimage') {
                clippedimagesObject.push(id);
            }else if (type === 'vignetteimage') {
                vignetteimagesObject.push(id);
            }else if (type === 'supplementaryimage') {
                supplementaryimagesObject.push(id);
            }else if (type === 'lifestyleimage') {
                lifestyleimagesObject.push(id);
            }else if (type === 'packagingimage') {
                packagingimagesObject.push(id);
            }else if (type === 'websitevideo') {
                websitevideoObject.push(id);
            }else if (type === 'installationvideo') {
                installationvideoObject.push(id);
            } else if (type === 'threesixty') {
                threeSixtyObject.push(id);
            }
	});

	function isUnique(value, index, self) {
		return self.indexOf(value) === index;
	}

	let groupedGalleryImageIDs = galleryimagesObject.filter(isUnique).join(','),
	groupedClippedImageIDs = clippedimagesObject.filter(isUnique).join(','),	
	groupedVignetteImageIDs = vignetteimagesObject.filter(isUnique).join(','),
	groupedSupplementaryImageIDs = supplementaryimagesObject.filter(isUnique).join(','),	
	groupedLifestyleImageIDs = lifestyleimagesObject.filter(isUnique).join(','), 
	groupedPackagingImageIDs = packagingimagesObject.filter(isUnique).join(','), 
	groupedWebsiteVideoIDs = websitevideoObject.filter(isUnique).join(','), 
	groupedInstallationVideoIDs = installationvideoObject.filter(isUnique).join(','), 
	grouped360IDs = threeSixtyObject.filter(isUnique).join(',');

	//Click function for the more images button
	$('body').on('click', '.js-more-product-media', function(e){
		$('.js-product-media-item.state-hidden').each(function(){
			var $item = $(this);
			var $itemIndex = $item.index() - 5;

			setTimeout(function(){
				$item.fadeIn(200);
			}, $itemIndex * 200);
		});

		$(this).remove();
		e.preventDefault();
	});

	initModal(groupedGalleryImageIDs, groupedClippedImageIDs, groupedVignetteImageIDs, 
		groupedSupplementaryImageIDs, groupedLifestyleImageIDs, groupedPackagingImageIDs,
		groupedWebsiteVideoIDs, groupedInstallationVideoIDs, grouped360IDs);
}


function initModal(galleryImageIDs, clippedImageIDs, vignetteImageIDs, supplementaryImageIDs, lifestyleImageIDs, packagingImageIDs, websiteVideoIDs, installationVideoIDs, grouped360IDs){
	$('.js-product-media-item').each(function(){
		let $link = $(this).find('.js-product-media-link');
		let currentItemId = $(this).data('id');
		let isSingleImage;

		let imageIds = clippedImageIDs.concat(vignetteImageIDs, supplementaryImageIDs, lifestyleImageIDs, galleryImageIDs, packagingImageIDs, websiteVideoIDs, installationVideoIDs, grouped360IDs);
		imageIds.length < 1 ? (isSingleImage = '&singleImage=true') : (isSingleImage = '');

		var fullUrlWithParams = `?ids=${galleryImageIDs},clippedids:${clippedImageIDs},vignetteids:${vignetteImageIDs},supplementaryids:${supplementaryImageIDs},lifestyleids:${lifestyleImageIDs},packagingids:${packagingImageIDs},websiteids:${websiteVideoIDs},installationids:${installationVideoIDs},threesixty:${grouped360IDs}${isSingleImage}`;
		if (currentItemId) {
			fullUrlWithParams = fullUrlWithParams.concat("&selectedItem=" + currentItemId);
		}

		if(RegionHelper.detectLanguage() === "es" || RegionHelper.detectLanguage() === "fr") {
			$link.attr('href', `/${RegionHelper.detectLanguage()}/modal${fullUrlWithParams}`);
		} else {
			$link.attr('href', '/modal' + fullUrlWithParams);
		}
	});
}

export function init() {
	initProductMedia();
}
